// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpinnerLoader_spinner__QFtHw {
  display: inline-block;
  animation: SpinnerLoader_spin__ZsDcN 1s linear infinite;
  flex-shrink: 0;
}

@keyframes SpinnerLoader_spin__ZsDcN {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/Loader/SpinnerLoader.module.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,uDAAA;EACA,cAAA;AACF;;AAEA;EACE;IACE,uBAAA;EACF;EACA;IACE,yBAAA;EACF;AACF","sourcesContent":[".spinner {\n  display: inline-block;\n  animation: spin 1s linear infinite;\n  flex-shrink: 0;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner": `SpinnerLoader_spinner__QFtHw`,
	"spin": `SpinnerLoader_spin__ZsDcN`
};
export default ___CSS_LOADER_EXPORT___;
